module.exports = __webpack_public_path__ + "img/10018.b4682bb3.jpg";